/**
 * The producer card titles that are part of a work item's **identity**, not
 * just its copy.
 *
 * `work_items` carries no subtype column, so the web client tells a link-less
 * card by its title and routes a click on it, and the backend writes the card
 * with the same string. That is why the constants live in the leaf package
 * both can import rather than being spelled twice. The phone card is raised
 * and found by its `nux_goal_key`, so no producer read keys on its title.
 *
 * Changing a string orphans every stored row wearing the old one; migrate them
 * in the same change.
 */

/** The card asking a member to verify the phone number on their account. */
export const UNVERIFIED_PHONE_WORK_ITEM_TITLE = 'Verify your phone number';
